import { PlDialog } from "./pl--dialog.js"

/**
 * PlMobileMenuDrawer - Custom element for mobile menu drawer
 * Extends PlDialog and handles open/close logic
 */
class PlMobileMenuDrawer extends PlDialog {
  connectedCallback() {
    super.connectedCallback()
    this.#attachMenuListeners()
  }

  #attachMenuListeners() {
    // Listen for manual open requests
    document.addEventListener("menu:open", () => this.open())

    // Auto-bind all [data-menu-open] buttons
    document.querySelectorAll("[data-menu-open]").forEach((button) => {
      button.addEventListener("click", () => this.open())
    })

    // Handle close button clicks inside drawer
    const closeButtons = this.querySelectorAll("[data-mobile-menu-close]")
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.close())
    })

    // Close drawer when a menu link is clicked (navigation)
    this.addEventListener("click", (event) => {
      const link = event.target.closest("a.pl--mobile-menu-item__link")
      if (link && link.href) {
        // Small delay to allow navigation
        setTimeout(() => this.close(), 100)
      }
    })
  }
}

if (!customElements.get("pl-mobile-menu-drawer")) {
  customElements.define("pl-mobile-menu-drawer", PlMobileMenuDrawer)
}

export { PlMobileMenuDrawer }
